<template lang="pug">
  .component-array-edit
    .input-group
      input.input-group-field(type='text', v-model="newName")
      .input-group-button
        button.button.fa.fa-plus(@click="addField" :disabled="!newName")
    .input-group(v-if="options !== null" )
      select.input-group-field(v-model="newName")
        template(v-for="(groups) in options" )
          optgroup(v-for="(group, groupName) in groups", :label="groupName", :key="groupName")
            template(v-for="(options) in group")
              option(v-for="(item, key) in options", :value="key") {{ item }}
      .input-group-button
        button.button.fa.fa-plus(@click="addField" :disabled="!newName")
    .prop-item(v-for="(value,label) in values", v-if="typeof value !== 'undefined'")
      .input-group
        span.input-group-label {{label}}
        input.input-group-field(type='text', v-model="values[label]")
        .input-group-button
          button.button.warning.fa.fa-times(@click="removeField(label)")
</template>

<script>


export default {
  name: 'ArrayEdit',
  data() {
    return {
      newName: null
    }
  },
  methods: {
    addField() {
      try {
        var values = JSON.parse(`${this.newName}`)

        for (var key in values) {
          this.$set(this.values, key, values[key])

        }
        this.newName = null
      } catch (e) {
        this.$set(this.values, this.newName, "--")
        this.newName = null
        return false;
      }
    },
    removeField(label) {
      this.$delete(this.values, label)
    }
  },
  props: {
    values: {
      type: Object
    },
    options: {
    }
  }
}
</script>

<style lang="sass">

</style>



// WEBPACK FOOTER //
// ArrayEdit.vue?126bacd0